import axiosInstance from '../../utils/axiosInstance';
import endpoints from '../../utils/endpoints';
import serializeStrapiParams from '../../utils/serializeStrapiParams';

// Strapi locale updates must use the locale query param and exclude
// the locale field from the request body.
const buildLocalePayload = (data) => {
  const { locale: _locale, ...rest } = data || {};

  return {
    data: rest,
  };
};

const find = async (query) => {
  const { data } = await axiosInstance.get(endpoints.routes(), {
    params: query,
    paramsSerializer: (params) => {
      const pairs = serializeStrapiParams(params);
      return pairs.join('&');
    },
  });
  return data;
};

const findOne = async (id, locale = 'lt-LT') => {
  const sid = String(id);
  if (!id || sid.trim() === '' || sid.startsWith(':')) {
    throw new Error('Route ID is required');
  }
  const { data } = await axiosInstance.get(
    `${endpoints.routes(sid)}?locale=${locale}`
  );
  return data;
};

const create = async (data, locale = 'lt-LT') => {
  const payload = {
    data: {
      ...data,
      locale,
    },
  };

  const { data: route } = await axiosInstance.post(endpoints.routes(), payload);
  return route;
};

const update = async (id, data, locale = 'lt-LT') => {
  if (!id) {
    throw new Error('Route ID is required');
  }
  const payload = buildLocalePayload(data);
  const { data: route } = await axiosInstance.put(
    `${endpoints.routes(id)}?locale=${locale}`,
    payload
  );
  return route;
};

const remove = async (id) => {
  if (!id) {
    throw new Error('Route ID is required');
  }
  const response = await axiosInstance.delete(endpoints.routes(id));
  // Strapi returns 204 No Content on success; response body may be empty
  return response?.data;
};

const createLocalization = async (id, data, locale) => {
  if (!id) {
    throw new Error('Route ID is required');
  }
  const endpoint = endpoints.routes(id);
  const url = `${endpoint}?locale=${locale}`;

  const requestData = buildLocalePayload(data);
  
  try {
    const response = await axiosInstance.put(url, requestData);
    return response.data;
  } catch (error) {
    const errorInfo = {
      url,
      id,
      locale,
      status: error.response?.status,
      statusText: error.response?.statusText,
      errorData: error.response?.data,
    };
    
    console.error('Error creating localization:', errorInfo);
    
    if (error.response?.status === 404) {
      const errorMessage = 
        `Failed to create ${locale} localization: Endpoint not found (404). ` +
        `URL: ${url}. ` +
        `Please verify: 1) i18n plugin is installed and enabled, ` +
        `2) Strapi server has been restarted after enabling i18n, ` +
        `3) Route content type has i18n enabled in schema.`;
      throw new Error(errorMessage);
    }
    
    throw error;
  }
};

const client = { find, findOne, create, update, remove, createLocalization };

export default client;
